/**
 * 演示环境（?demo=1 / MockRoomBackend）的大厅与作战台联合引导。
 *
 * Mock 后端沿用「教师端权威」语义：只有房间创建者（角色被置为 TEACHER）可以开赛；
 * 辩手通过加入房间进入作战台，但无法自己开赛。离线演示时，为了让辩手端 HUD
 * 立刻有真实数据流（发牌 / 双表计时 / 揭示），这里提供一次显式的降级：
 *
 * 1. 先用当前身份尝试 `startMatch()`（辩手身份会被后端拒绝）；
 * 2. 若仍是 LOBBY，则补建一个本地演示房间取得权威身份，再开赛并回到作战台。
 *
 * 真实 P2P 房间（教师端权威）不会走到第 2 步：辩手端只消费下发的时钟与状态。
 */
import { generateRoomCode } from '@zongheng/core-schema';
import type { IdentityInput, RoomBackend } from '../../state/types.ts';

/** 根据后端连接描述判断当前是否为离线演示（Mock）后端 */
export function isDemoSession(session: {
  capabilityNotes: readonly string[];
  connectionDetail: string;
}): boolean {
  const { connectionDetail } = session;
  return connectionDetail.includes('演示') || connectionDetail.includes('Mock');
}

/** 尝试在当前房间开赛；演示模式下若身份不足则补建本地权威房间 */
export async function startDemoMatch(
  actions: RoomBackend,
  fallbackIdentity: IdentityInput,
  roomCode?: string,
): Promise<void> {
  actions.startMatch();
  if (actions.getState().phase === 'RUNNING') return;

  await actions.createRoom(fallbackIdentity, roomCode ?? generateRoomCode());
  actions.startMatch();
  // 创建房间会把路由切到教练台；演示开赛需回到作战台。
  actions.setRoute('arena');
}

/** 生成 6 位房间码（大厅创建房间用） */
export function makeRoomCode(): string {
  return generateRoomCode();
}
